import { ButtonSubmit } from '../../styles';
import { getQueryParam, translate } from 'src/utils';
import {
  ThirdPartySSOLoginControls,
  ThirdPartySSOLoginHead,
  ThirdPartySSOLoginNote,
  ThirdPartySSOLoginStyled
} from './styles';

interface IThirdPartySSOLogin {
  onSSOLogin: () => void,
}

export const ThirdPartySSOLogin = ({ onSSOLogin }: IThirdPartySSOLogin) => (
  <ThirdPartySSOLoginStyled>
    <ThirdPartySSOLoginHead>
      <h1>{translate({ key: 'sso.login.title' })}</h1>
      <p>
        {translate({ key: 'sso.login.third_party_sso.desc' })}
      </p>
    </ThirdPartySSOLoginHead>

    <ThirdPartySSOLoginControls>
      <ButtonSubmit
        size="l"
        onClick={onSSOLogin}
        className="testing__button-sso"
      >
        {translate({ key: `sso.buttons.login_sso.${getQueryParam('broker') ?? 'default'}` })}
      </ButtonSubmit>
    </ThirdPartySSOLoginControls>

    <ThirdPartySSOLoginNote>
      {translate({ key: 'sso.login.third_party_sso.note' })}
    </ThirdPartySSOLoginNote>
  </ThirdPartySSOLoginStyled>
);
